// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as _googleTypes from 'signin-with-google-types'

import api from 'js/api'
import { googleLoginId } from 'js/config'

function getLoginToken() {
  return new Promise((resolve) => {
    window.google.accounts.id.initialize({
      client_id: googleLoginId as string,
      callback: ({ credential }) => {
        resolve(credential)
      },
    })
    window.google.accounts.id.prompt()
  })
}

export const loginWithGoogle = () => {
  return new Promise((resolve, reject) => {
    getLoginToken()
      .then((token) => {
        return api('POST', 'gatekeeper/v1/login/google/token', {
          token,
        })
      })
      .then(({ access_token, expires_at }) => {
        resolve({
          access_token,
          expires_at,
        })
      })
      .catch((error) => {
        return reject(error)
      })
  })
}
